import { Route, RouteComponentProps, Switch } from "react-router";

import AccessIntelSecuredPage from "Views/Components/Security/AccessIntelSecuredPage";
import { PageBreadcrumbs } from "Views/Components/Breadcrumbs/PageBreadcrumbs";
import classNames from "classnames";
import { MotorVehicleSearchRequestContent } from "Views/Components/SearchRequests/MotorVehicleSearchRequestContent";

const Tags = [
	{ label: 'Motor Vehicle Searches' },
]

export interface VehicleSearchesPageProps extends RouteComponentProps { }

const VehicleSearchesPage = (props: VehicleSearchesPageProps) => {
	const { match, location } = props;
	const { path } = match;

	return (
		<AccessIntelSecuredPage routeComponentProps={props}>
			<div className="body-content list-page">
				<div className="top-container">
					<PageBreadcrumbs tags={Tags} />
				</div>

				<div className={classNames('white-box')}>
					<Switch>
						<Route
							path={`${path}/generate`}
							component={() => <MotorVehicleSearchRequestContent showSearchModal={true} />}
						/>
						<Route
							path="/"
							component={() => <MotorVehicleSearchRequestContent />}
						/>
					</Switch>
				</div>
			</div>
		</AccessIntelSecuredPage>
	);
};

export default VehicleSearchesPage;